module.exports = window["MaterialUI"].Icon;